import { containsWhitespace } from '@/utils/strings'

function isValidUrl(urlString: string): boolean {
  // We're using a lenient regex here rather than using zod to decrease the
  // chance of blocking users eg if they forget to include https://
  const urlPattern = /^(https?:\/\/)?([\w.-]+)\.([\w]{2,6})([\S]*)*\/?$/
  return urlPattern.test(urlString)
}

export default function parseLinksString(links: string | null): string[] {
  if (links == null || links.trim().length === 0) {
    return []
  }

  const linksList = links.split(',').map(link => link.trim())
  linksList.forEach(link => {
    if (containsWhitespace(link)) {
      throw new Error(
        `Link "${link}" should not contain whitespace. If it is meant to be separate links, please separate using a comma.`
      )
    }
    if (!isValidUrl(link)) {
      throw new Error(
        `"${link}" does not appear to be a valid URL. Please ensure all entries are valid links.`
      )
    }
  })
  return linksList
}
